import { AgeCategory } from '../types/categories';


// get age based on birth date
export const getAge = (birthDate: string, when?: string) => {
  if (!birthDate || birthDate === '') return undefined;

  const date = new Date(birthDate);
  const currentDate = when ? new Date(when) : new Date();
  const diffInMilliseconds = currentDate.getTime() - date.getTime();

  const diffInYears = diffInMilliseconds / (1000 * 60 * 60 * 24 * 365.25);

  return Number(diffInYears.toFixed(1));
};


// get age category based on birth date (u21, u25, u29, 30+)
export const getAgeCategory = (birthDate: string, when?: string): AgeCategory | undefined => {
  if (!birthDate || birthDate === '') return undefined;

  const birthYear = birthDate.split('-')[0];
  const referenceYear = when ? when.split('-')[0] : new Date().toISOString().split('-')[0];
  const yearDiff = Number(referenceYear) - Number(birthYear);

  if (yearDiff !== undefined) {
    if (yearDiff < 22) return 'U21';
    if (yearDiff < 26) return 'U25';
    if (yearDiff < 30) return 'U29';
    return '29+';
  }
};


// get a value between 0 and 10 based on the age
export const getAgeIndexEquivalent = (age: number | undefined, isAcademyTeam?: boolean): number | undefined => {
  if (!age) return undefined;

  const maxAge = isAcademyTeam ? 25 : 33;
  const minAge = isAcademyTeam ? 13 : 17;

  age = Math.min(maxAge, Math.max(minAge, age));

  const percent = 1 - (age - minAge) / (maxAge - minAge);
  return percent * 10;
};


// get a value between 0 and 10 based on the age category
export const getAgeCategoryIndexEquivalent = (ageCategory: AgeCategory | undefined): number | undefined => {
  if (ageCategory === 'U21') return 10;
  if (ageCategory === 'U25') return 6;
  if (ageCategory === 'U29') return 3;
  if (ageCategory === '29+') return 0;
};
